import {createReducer} from '@reduxjs/toolkit';
import {
  set as setGeometry,
  setByCoordinate as setGeometryByCoordinate,
  setByExtent as setGeometryByExtent,
} from '../actions/geometry.js';
import {load, loadNextPage} from '../actions/quads.js';

const initialState = {
  loading: false,
  error: null,
  items: [],
  nextPage: null,
};

export default createReducer(initialState, builder => {
  builder.addCase(load.pending, state => {
    state.loading = true;
    state.error = null;
    state.items = [];
    state.nextPage = null;
  });

  builder.addCase(
    load.fulfilled,
    (state, {payload: {quads: items, nextPage}}) => {
      state.loading = false;
      state.error = null;
      state.items = state.items.concat(items);
      state.nextPage = nextPage;
    },
  );

  builder.addCase(load.rejected, (state, {payload: error}) => {
    state.loading = false;
    state.error = error;
  });

  builder.addCase(loadNextPage.pending, state => {
    state.loading = true;
    state.error = null;
  });

  builder.addCase(
    loadNextPage.fulfilled,
    (state, {payload: {quads: items, nextPage}}) => {
      state.loading = false;
      state.error = null;
      state.items = state.items.concat(items);
      state.nextPage = nextPage;
    },
  );

  builder.addCase(loadNextPage.rejected, (state, {payload: error}) => {
    state.loading = false;
    state.error = error;
  });

  builder.addCase(setGeometry, () => initialState);
  builder.addCase(setGeometryByCoordinate, () => initialState);
  builder.addCase(setGeometryByExtent, () => initialState);
});
